import { ProductCategory, FeaturedProduct, Testimonial } from "./types";

export const productCategories: ProductCategory[] = [
  {
    id: "flower",
    title: "Premium Flower",
    description:
      "Hand-selected strains with exceptional aroma, flavor profiles, and effects for the discerning cannabis connoisseur.",
    image: "/images/kief-infused-joints-inside-dispensary.jpg",
    imageWebp: "/images/kief-infused-joints-inside-dispensary.webp",
    link: "/products/flower",
  },
  {
    id: "vapes",
    title: "Vape Cartridges",
    description:
      "Convenient, discreet, and potent cannabis oil cartridges in a variety of strain-specific formulations.",
    image: "/images/vape-cartridges.jpg",
    imageWebp: "/images/vape-cartridges.webp",
    link: "/products/vape-carts",
  },
  {
    id: "edibles",
    title: "Edibles",
    description:
      "Delicious cannabis-infused treats offering precise dosing and long-lasting effects without inhalation.",
    image: "/images/edibles-at-street-lawyer-services.jpg",
    imageWebp: "/images/edibles-at-street-lawyer-services.webp",
    link: "/products/edibles",
  },
  {
    id: "concentrates",
    title: "Concentrates",
    description:
      "Potent cannabis extracts for experienced consumers seeking powerful effects and maximum THC content.",
    image: "/images/variations-of-thc-concentrates.gif",
    imageWebp: "",
    link: "/products/concentrates",
  },
];

export const featuredProducts: FeaturedProduct[] = [
  {
    id: "product-1",
    name: "Wedding Cake",
    category: "Premium Flower",
    image: "/images/weed-joints-with-kief.jpg",
    imageWebp: "/images/weed-joints-with-kief.webp",
  },
  {
    id: "product-2",
    name: "Durban Poison",
    category: "Sativa Strain",
    image: "/images/weed-jar-and-street-lawyer-services-logo-1.jpg",
    imageWebp: "/images/weed-jar-and-street-lawyer-services-logo-1.webp",
  },
  {
    id: "product-3",
    name: "Blue Dream Pre-Rolls",
    category: "Pre-Rolls",
    image: "/images/kief-infused-joints-inside-dispensary.jpg",
    imageWebp: "/images/kief-infused-joints-inside-dispensary.webp",
  },
  {
    id: "product-4",
    name: "Strawberry Gummies",
    category: "Edibles",
    image: "/images/edibles.jpg",
    imageWebp: "/images/edibles.webp",
  },
  {
    id: "product-5",
    name: "OG Kush",
    category: "Hybrid Strain",
    image: "/images/weed-jars-from-street-lawyer-services.jpg",
    imageWebp: "/images/weed-jars-from-street-lawyer-services.webp",
  },
  {
    id: "product-6",
    name: "Sour Diesel Carts",
    category: "Vape Carts",
    image: "/images/vape-cartridges.jpg",
    imageWebp: "/images/vape-cartridges.webp",
  },
];

export const testimonials: Testimonial[] = [
  {
    id: "testimonial-1",
    quote:
      "Street Lawyer Services offers the best selection of premium cannabis products in DC. Their knowledgeable staff helped me find exactly what I needed.",
    author: "Michael J.",
    location: "Washington, DC",
  },
  {
    id: "testimonial-2",
    quote:
      "I'm impressed by the quality and variety of products. The staff is incredibly helpful and takes time to explain different strains and their effects.",
    author: "Sarah T.",
    location: "Arlington, VA",
  },
  {
    id: "testimonial-3",
    quote:
      "As a medical customer with specific needs, I appreciate how the team at Street Lawyer Services always recommends products that actually help with my symptoms.",
    author: "David L.",
    location: "Silver Spring, MD",
  },
];
